module.exports = __webpack_public_path__ + "static/media/August2022Newsletter.1e681e1e.pdf";